import React from "react";
import MainLayout from "../../MainLayout.tsx";
import TextImageGrid from "../../../components/grids/textImageGrid.component.tsx";
import colors from "../../../constants/colors.ts";
import { imagesFoldersTypes } from "../../../constants/app.constants.ts";

const Section9: React.FC = () => {
  return (
    <MainLayout>
      <TextImageGrid
        backgroundColor={colors.BLUE_DDEFFF}
        title={"TITLE.ServiciiIncluse"}
        text={"TEXT.BeneficiiPentruCompanii"}
        image={'Massage-Chair'}
        imageVariant={imagesFoldersTypes.IMAGES}
      />
    </MainLayout>
  );
};

export default Section9;
